export const development = {
  production: false,
  name: "development",
  useEmulators: false,
  commit: '52a90b6629cf9772d2a7ba1af67ff78d0f2961f5',
  firebase: {
    apiKey: 'AIzaSyDXpx2gLDPIz5sO8JpCbtsw3FWegs8b4CU',
    authDomain: 'smooth-keel-220613.firebaseapp.com',
    databaseURL: 'https://smooth-keel-220613.firebaseio.com',
    projectId: 'smooth-keel-220613',
    storageBucket: 'smooth-keel-220613.appspot.com',
    messagingSenderId: '199161905756',
    appId: '1:199161905756:web:a273813309acedaf8e1c99',
    measurementId: 'G-MBSLKE6QNR',
  },
  recaptcha: {
    siteKey: '6LfCbMYrAAAAAFjyvnFWBH0IF4TqyFPIggbGoA5Q',
  },
  urls: {
    segue: 'http://localhost:4200',
    segui: 'http://localhost:4201',
    xview: 'http://localhost:4202',
    console: 'http://localhost:4203',
    // meshBaseUrl:'/assets/models', // for testing local mesh generation
    meshBaseUrl: 'https://storage.googleapis.com/3d-smooth-keel-220613/models',
  }
};
